import { PostTypes } from 'constants/postTypes'

import { useMutation } from 'hooks/useMutation'

import { completePost } from 'utils/queries'
import { Toast } from 'utils/toast'
import { computeNewUpscore } from 'utils/upscore'

import { Post } from 'types/post'
import { Data } from 'types/query'
import { UserType } from 'types/user'

import { useCurrentUser } from './useCurrentUser'
import { useQueryClient } from './useQueryClient'

export const usePostCompletion = (post: Post) => {
  const queryClient = useQueryClient()
  const { data: currentUser } = useCurrentUser()

  const complete = useMutation(
    async (data: { user: UserType; date: number }) => {
      const programData = post.program
        ? { program: { id: post.program?.id, trainer: { id: post.program?.trainer?.id } } }
        : {}

      return completePost({
        ...data,
        post: {
          id: post.id,
          isArchived: post.isArchived,
          creator: { id: post.creator.id },
          programIds: post.programIds,
          ...programData,
        },
      })
    },
    {
      onError: () => {
        Toast.error('Unable to complete post', 'Something went wrong, please try again.')
      },
      onSuccess: () => {
        queryClient.invalidateQueries(['leaderboard'])

        queryClient.setQueryData(['user', currentUser?.id], (data: Data) => {
          const newDailyCompletions = data.dailyCompletions ? data.dailyCompletions + 1 : 1
          if (data) {
            // eslint-disable-next-line no-param-reassign
            data.upscore = computeNewUpscore(currentUser?.upscore, { type: PostTypes.WORKOUT })
            // eslint-disable-next-line no-param-reassign
            data.dailyCompletions = newDailyCompletions
          }
          return data
        })
      },
    },
  )

  return {
    // Mutation Objects
    complete,
  }
}
